
import {
  NgModule,
} from '@angular/core';

import {
  CommonModule,
} from '@angular/common';

import {
  themeAssetsProvider,
} from './theme.assets';

import {
  ThemeAppLayoutModule,
} from './ui/layouts/app-layout/app-layout.module';

import {
  ThemeCoreModule,
} from './core/core.module';

import {
  ThemePipesModule,
} from './pipes/pipes.module';

import {
  ThemeComponentsAsideModule,
} from './ui/components/aside/aside.module';

import {
  ThemeComponentsAvatarModule,
} from './ui/components/avatar/avatar.module';

import {
  ThemeComponentsCardModule,
} from './ui/components/card/card.module';

import {
  ThemeComponentsContentModule,
} from './ui/components/content/content.module';

import {
  ThemeComponentsCreditcardModule,
} from './ui/components/creditcard/creditcard.module';

import {
  ThemeComponentsDialogModule,
} from './ui/components/dialog/dialog.module';

import {
  ThemeComponentsFilterModule,
} from './ui/components/filter/filter.module';

import { ThemeComponentsLogoutModule } from './ui/components/logout/logout.module';


import {
  ThemeComponentsKycModule,
} from './ui/components/kyc/kyc.module';

import {
  ThemeComponentsLoaderModule,
} from './ui/components/loader/loader.module';

import {
  ThemeComponentsLozengeModule,
} from './ui/components/lozenge/lozenge.module';

import {
  ThemeComponentsMenuModule,
} from './ui/components/menu/menu.module';

import {
  ThemeComponentsMessageModule,
} from './ui/components/message/message.module';

import { 
  ThemeComponentsPaginationModule,
} from './ui/components/pagination/pagination.module';

import {
  ThemeComponentsProfileModule,
} from './ui/components/profile/profile.module';

import {
  ThemeComponentsProgressBarModule,
} from './ui/components/progress-bar/progress-bar.module';

import {
  ThemeComponentsScrollbarModule,
} from './ui/components/scrollbar/scrollbar.module';

import {
  ThemeComponentsShimmerModule,
} from './ui/components/shimmer/shimmer.module';

import {
  ThemeComponentsTableModule,
} from './ui/components/table/table.module';

import {
  ThemeComponentsThumbnailModule,
} from './ui/components/thumbnail/thumbnail.module';

import {
  ThemeDirectivesHeaderModule,
} from './ui/directives/header/header.module';

import {
  ThemeDirectivesFooterModule,
} from './ui/directives/footer/footer.module';

import {
  ThemeDirectivesInfoModule,
} from './ui/directives/info/info.module';

import {
  ThemeDirectivesSelectedModule,
} from './ui/directives/selected/selected.module';

import {
  ThemeDirectivesSizeModule,
} from './ui/directives/size/size.module';

import {
  ThemeDirectivesSectionModule,
} from './ui/directives/section/section.module';

import {
  ThemeDirectivesTitleModule,
} from './ui/directives/title/title.module';


@NgModule({
  imports: [
    CommonModule,
  ],

  exports: [
    ThemeAppLayoutModule,
    ThemeCoreModule,
    ThemePipesModule,
    ThemeComponentsAsideModule,
    ThemeComponentsAvatarModule,
    ThemeComponentsCardModule,
    ThemeComponentsContentModule,
    ThemeComponentsCreditcardModule,
    ThemeComponentsDialogModule,
    ThemeComponentsFilterModule,
    ThemeComponentsLogoutModule,
    ThemeComponentsKycModule,
    ThemeComponentsMenuModule,
    ThemeComponentsMessageModule,
    ThemeComponentsLoaderModule,
    ThemeComponentsLozengeModule,
    ThemeComponentsPaginationModule,
    ThemeComponentsProfileModule,
    ThemeComponentsProgressBarModule,
    ThemeComponentsScrollbarModule,
    ThemeComponentsShimmerModule,
    ThemeComponentsTableModule,
    ThemeComponentsThumbnailModule,
    ThemeDirectivesHeaderModule,
    ThemeDirectivesFooterModule,
    ThemeDirectivesInfoModule,
    ThemeDirectivesSelectedModule,
    ThemeDirectivesSectionModule,
    ThemeDirectivesSizeModule,
    ThemeDirectivesTitleModule,
  ],

  providers: [
    themeAssetsProvider,
  ],
})
export class ThemeModule { }
